/* eslint-disable max-len */
const React = require('react');
const Card = require('@andes/card');
const { CardContent } = require('@andes/card');
const { getEventTracker } = require('../../../../../utils/event-tracker');
const { isYellowBlueLightBrand } = require('../../../../../utils/isYellowBlueLightBrand');

const CardFormat = ({ icon, title, description, link, event, labelElement, brand }) => {
  const Tracker = getEventTracker();

  const sendToMelidata = (data) => {
    Tracker.melidata.send('/developers/click_gallery', {
      product_name: data,
    }, {
      autoDocsRefInfo: true,
    });
  };

  return (
    <a href={link} className="docs-card-a" onClick={() => { Tracker.send('mpdevelopers/documentation/click_gallery', event); sendToMelidata(event); }} aria-label={labelElement}>
      <Card className={`docs-card ${isYellowBlueLightBrand(brand) ? 'docs-card-width-ml docs-card-border-ml' : 'docs-card-width-mp'}`} shadow="flat" paddingSize="0" animated>
        <CardContent className="docs-card-container">
          {icon}
          <div>
            <h5 className="docs-card-header">{title}</h5>
            <span className="docs-card-content">{description}</span>
          </div>
        </CardContent>
      </Card>
    </a>
  );
};

module.exports = CardFormat;
